import Crud from './crud'
import client from './client'

const ENDPOINT = '/site'

export default class SitesService extends Crud {
  constructor () {
    super(ENDPOINT)
  }

  search (query) {
    return client.get('api/site/search', {
      q: query,
    })
  }

  filter (query, params) {
    return client.post('api/site/filter', query, params)
  }

  forMap () {
    return client.post('api/site/for-map')
  }
}
